import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class Task {
  assignTask(data, config) {
    return axios.post(BASE_URL + "/admin/task/assignTask", data, config)
  }

  getAnalystUser(config) {
    return axios.get(BASE_URL + "/admin/auth/analystUserMenu", config)
  }

  getAllTask(config) {
    return axios.get(BASE_URL + "/admin/task/getTask", config)
  }

  updateTask(data, config) {
    return axios.put(BASE_URL + "/admin/task/updateTask", data, config)
  }

  getAnalystTaskById(userId, config) {
    return axios.get(
      `${BASE_URL}/admin/task/getAnalystTaskById/${userId}`,
      config,
    )
  }
  validateTargetCompletion(taskId,config){
    return axios.get(`${BASE_URL}/admin/task/validateTargetCompletion /${taskId}`,
      config,

    )
  }

  trackAllUserDailyOperations(config){
    return axios.get(`${BASE_URL}/admin/task/trackAllUserDailyOperations`,config,)
  }

  trackUserDailyOperations(userId,config){
    return axios.get(`${BASE_URL}/admin/task/trackUserDailyOperations/${userId}`, config,)
  }
}

export default new Task()
